import { store } from 'quasar/wrappers';
import { createStore } from 'vuex';

import accounts from './accounts';
import application from './application';
import assets from './assets';
import attributes from './attributes';
import auth from './auth';
import bookings from './bookings';
import categories from './categories';
import models from './models';
import notifications from './notifications';
import products from './products';
import history from './history';

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store((/* { ssrContext } */) => createStore({
  modules: {
    accounts,
    application,
    assets,
    attributes,
    auth,
    bookings,
    categories,
    models,
    notifications,
    products,
    history,
  },

  // enable strict mode (adds overhead!)
  // for dev mode and --debug builds only
  strict: process.env.DEBUGGING,
}));
